import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GitBranch, Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DivergentWidget() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await axios.get(`${API}/conflicts/today`, { params: { limit: 4 }, timeout: 6000 });
        if (alive) setItems(r.data.items || []);
      } catch { if (alive) setItems([]); }
    })();
    return () => { alive = false; };
  }, []);

  if (items === null) {
    return (
      <div className="rounded-xl border border-[var(--line)] bg-white p-4 flex items-center gap-2 text-[var(--muted)] text-[13px]">
        <Loader2 size={14} className="animate-spin" /> Loading divergent stories…
      </div>
    );
  }
  if (items.length === 0) return null;

  const toneClass = (c) => c >= 70
    ? "border-emerald-300 bg-emerald-50"
    : c >= 40 ? "border-[var(--gold)] bg-[#fff7d6]" : "border-rose-300 bg-rose-50";

  return (
    <section className="rounded-xl border border-[var(--line)] bg-white overflow-hidden" data-testid="divergent-widget">
      <div className="px-4 py-3 border-b border-[var(--line)] bg-gradient-to-r from-[#0a1f3d] to-[#1e40af] text-white flex items-center gap-2">
        <GitBranch size={14} className="text-[var(--gold)]" />
        <span className="text-[11px] uppercase tracking-[0.18em] font-black">Most Divergent Stories</span>
        <span className="text-[10px] opacity-80 ml-auto hidden sm:inline">Where outlets disagree most — read all sides</span>
      </div>
      <div className="divide-y divide-[var(--line)]">
        {items.map((it, idx) => (
          <div key={it.id || idx} className={`p-3 border-l-4 ${toneClass(it.confidence ?? 0)}`} data-testid={`divergent-item-${idx + 1}`}>
            <div className="flex items-center justify-between gap-2 mb-1">
              <span className="text-[12.5px] font-black text-[var(--ink)] leading-snug">{it.q}</span>
              <span className="text-[10px] uppercase tracking-[0.14em] font-black bg-white border border-[var(--line)] rounded-full px-2 py-0.5 text-[var(--ink)] whitespace-nowrap">
                {it.confidence ?? 0}% agreement
              </span>
            </div>
            {it.conflict_summary && (
              <p className="text-[11.5px] text-[var(--muted)] italic mb-1.5 leading-snug">{it.conflict_summary}</p>
            )}
            <div className="flex flex-wrap gap-1">
              {(it.camps || []).slice(0, 3).map((c, ci) => (
                <span key={ci} className="text-[10px] bg-white border border-[var(--line)] rounded px-1.5 py-0.5 font-bold text-[var(--ink)]">
                  {c.name}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="px-4 py-2 bg-[var(--bg)] border-t border-[var(--line)] text-[11px] text-[var(--muted)]">
        <Link to="/" className="font-black text-[var(--blue)]">Ask Newseze AI</Link> any question to add a new conflict brief.
      </div>
    </section>
  );
}
